export const ApiRoutes = {
  // API endpoints originally defined for legacy client
  adminEndImpersonation: () => '/admin/end_impersonation',
  clientChangeCommunityPath: () => '/client/1.0/change_community',
  clientCheckEmailPath: () => '/client/1.0/check_email_useable',
  clientCheckUsernamePath: () => '/client/1.0/check_username_useable',
  clientCommunitiesPath: () => '/client/1.0/communities',
  clientLocalePath: () => '/client/1.0/locale',
  clientLoginPath: () => '/client/1.0/login',
  clientRegisterAndSendActivationPath: () => '/client/1.0/register_user_and_send_activation',
  clientResetPasswordPath: () => '/client/1.0/reset_password',
  clientUploadCollectionImagePath: () => '/client/1.0/upload_collection_image',
  clientUploadCollectionImageDataPath: () => '/client/1.0/upload_collection_image_data',

  // Activity Stream API
  activityStream: {
    viewedPath: () => '/api/1.0/activity_stream/activity_stream_viewed',
    sourceEventsPath: () => '/api/1.0/activity_stream/activity_source_events',
    sourcesPath: () => '/api/1.0/activity_stream/activity_sources',
  },
  apiFollowUser: () => '/api/1.0/activity_stream/follow_user',
  apiUnfollowUser: () => '/api/1.0/activity_stream/unfollow_user',

  // Collections API
  collections: {
    addPath: () => '/api/1.0/collections/add',
    createPath: () => '/api/1.0/collections/create',
    infoPath: () => '/api/1.0/collection/info',
    itemsPath: () => '/api/1.0/collections/items',
    removeItemsPath: () => '/api/1.0/collections/remove_items',
    updateImagePath: () => '/api/1.0/collections/update_image',
    deletePath: () => '/api/1.0/collections/delete',
    updatePath: () => '/api/1.0/collections/update',
    updateOrderPath: () => '/api/1.0/collections/update_order',
  },

  // Content Library API
  apiActivateBookNoCodePath: () => '/api/1.0/libraries/activate_book_no_code',
  apiActivateLibraryCodePath: () => '/api/1.0/libraries/activate_code',

  // Community API
  apiCopyScoresToSitePath: () => '/api/1.0/communities/copy_scores',

  // Customer API
  apiCreateCustomerCard: () => '/api/1.0/customer/create_customer_card',
  apiUpdateCustomerCard: () => '/api/1.0/customer/update_customer_card',
  apiDeleteCustomerCard: () => '/api/1.0/customer/delete_customer_card',
  apiRetrieveCustomerCards: () => '/api/1.0/customer/retrieve_customer_cards',

  // Favorites API
  apiFavoritesRemoveScoresPath: () => '/api/1.0/favorites/remove_scores',

  // Marketplace API
  deactivateProduct: () => '/api/1.0/marketplace/products/deactivate',

  // Members API
  members: {
    createScorePath: () => '/api/1.0/members/create_score',
    deleteScoresPath: () => '/api/1.0/members/delete_scores',
    favoriteScoresPath: () => '/api/1.0/members/favorite_scores',
    messagesPath: () => '/api/1.0/members/messages',
    privateBooksPath: () => '/api/1.0/members/private_books',
    privateCollectionsPath: () => '/api/1.0/members/private_collections',
    privateScoresPath: () => '/api/1.0/members/private_scores',
    privateStatisticsPath: () => '/api/1.0/members/private_statistics',
    purchasedScoresPath: () => '/api/1.0/members/purchased_scores',
    removeScoresPath: () => '/api/1.0/members/remove_scores',
    restoreScoresPath: () => '/api/1.0/members/restore_scores',
    sharedScoresPath: () => '/api/1.0/members/shared_scores',
    templateCopiesPath: () => '/api/1.0/members/template_copies',
    trashPath: () => '/api/1.0/members/trash',
  },

  // Product Purchase API
  apiPurchaseProduct: () => '/api/1.0/product_purchase/purchase_product',
  apiTaxLookupAddress: () => '/api/1.0/product_purchase/tax_lookup_address',
  apiTaxLookupCard: () => '/api/1.0/product_purchase/tax_lookup_card',

  // Scores API
  apiScoresPrivateCollectionsPath: () => '/api/1.0/scores/private_collections',

  // Searchable Object API
  apiSearchSuggestionsPath: () => '/api/1.0/search/suggestions',

  // Shared API
  apiSharedRemoveScoresPath: () => '/api/1.0/shared/remove_scores',

  social: {
    commentsByScore: () => '/api/1.0/social/comments_by_score',
    commentsByTimeframe: () => '/api/1.0/social/comments_by_timeframe',
    favoritesByScore: () => '/api/1.0/social/favorites_by_score',
    favoritesByTimeframe: () => '/api/1.0/social/favorites_by_timeframe',
    viewsByScore: () => '/api/1.0/social/views_by_score',
    viewsByTimeframe: () => '/api/1.0/social/views_by_timeframe',
  },

  // SoundCheck API
  apiCreateSoundCheckAssignment: () => '/api/1.0/soundcheck/assignment',

  // Stripe API
  apiStripePaymentIntents: () => `/api/1.0/stripe_payment_intents`,

  // Subscriptions API
  apiPremiumSubPricingPath: () => '/api/1.0/premium_subscription_pricing',
  apiLearnSubPricingPath: () => '/api/1.0/learn_subscription_pricing',

  // Titles API
  apiAddFavoriteTitlePath: () => '/api/1.0/titles/add_favorite',
  apiCreateTitleCopy: () => '/api/1.0/titles/create_title_copy',
  apiRemoveFavoriteTitlePath: () => '/api/1.0/titles/remove_favorite',
  apiPurchasedProduct: (uuid: string) => `/api/1.0/titles/${uuid}/purchased_product`,
  apiTitlePrivateCollectionsPath: (uuid: string) => `/api/1.0/titles/${uuid}/private_collections`,
  apiTitleUnpublishPath: () => `/api/1.0/titles/unpublish_community_title`,

  // Other
  contentItemPath: (itemName: string) => `/content_item/${itemName}`,
}
export default ApiRoutes

// map Page Data API endpoints to react route pathnames.
// Assume they're the same if not specified
export const endpointForPathname = (pathname): string => {
  return pathname
}
